<template>
  <div id="app">
    <Rules/>
    <Header/>
    <div class="top-title">
      <b-row>
        <b-col class="title">
          <p>FOODORATOR BY <img class="coralie-logo" :src="require('./assets/Coralie-logo1.png')"></p>
        </b-col>
        <b-col class="login-button">
          <b-button class="custom-button" @click="redirectToLogin" v-if="!isLogged">Espace Coralie</b-button>
          <b-button class="custom-button" @click="logout" v-else-if="isLogged">Déconnexion</b-button>
        </b-col>
      </b-row>
    </div>
    <router-view class="view"></router-view>
  </div>
</template>

<script>
import store from 'store';
import { isNil } from 'lodash';
import Header from './components/header.vue';
import Rules from './components/rules.vue';
export default {
  name: 'app',
  components: {
    Header,
    Rules
  },
  data: () => ({
    isLogged: false
  }),
  methods: {
    redirectToLogin() {
      _.isNil(store.get('token')) ? this.$router.push('login') : this.$router.push('admin');
    },
    logout() {
      store.remove('token');
      this.$router.push('/');
      this.isLogged = false;
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.rules-modal {
  margin: auto;
}
.custom-card {
  margin-bottom: 5%;
}
#rights > .card-header {
  background-color: #f69a31;
}
#allow > .card-header {
  background-color: #57e77b;
}
#break > .card-header {
  color: #ffffff;
  background-color: #e91d23;
}
#except > .card-header {
  background-color: #d78eb4;
}
#howto > .card-header {
  color: #ffffff;
  background-color: #000000;
}
#nb {
  font-style: italic;
  font-size: 11px;
}
.coralie-logo {
  max-width: 20%;
  margin-top: -7px;
}
.top-title {
  color: #ac5e13;
  // background-color: #ac5e13;
  font-size: 40px;
}
.title {
  text-align: left;
  margin-bottom: -10px;
  margin-left: 1%;
  letter-spacing: -4px;
  font-weight: bold;
}
.custom-button {
  color: #ac5e13 !important;
  background-color: #fff !important;
  float: right;
  margin: 1%;
}
.custom-button:hover {
  color: #fff !important;
  background-color: #ac5e13 !important;
}
</style>
